exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".content-container{text-align:center}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/AddToHomeScreen/src/components/AddToHomeScreen/AddToHomeScreen.scss"],"names":[],"mappings":"AAAA,mBACE,iBAAA,CAAA","file":"AddToHomeScreen.scss","sourcesContent":[".content-container {\n  text-align: center;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./src/components/AddToHomeScreen/AddToHomeScreen.scss
// module id = 489
// module chunks = 16